import { useMemo } from 'react';

import { currentUser } from '@admin/config/current_user';
import { hasPermission, hasResourceAction, permissionKey } from '@admin/libraries/access_control';
import type { PermissionAction, PermissionResource } from '@admin/libraries/access_control_catalog.generated';

export const useGrantedPermissions = (): readonly string[] => currentUser.granted_permissions ?? [];

export const usePermission = (resource: PermissionResource, action: PermissionAction): boolean => {
  const grantedPermissions = useGrantedPermissions();
  return useMemo(() => hasResourceAction(resource, action, grantedPermissions), [resource, action, grantedPermissions]);
};

export const usePermissionKey = (key: string): boolean => {
  const grantedPermissions = useGrantedPermissions();
  return useMemo(() => hasPermission(key, grantedPermissions), [key, grantedPermissions]);
};

export { hasPermission, hasResourceAction, permissionKey };
